import { tprStorage } from "./storage";

const KEY = "tpr-known-user";

export interface KnownUser {
  email: string;
  firstName?: string;
  avatar?: string;
}

/** Persist ONLY a display hint (never a token or the full member). */
export function setKnownUser(hint: KnownUser): void {
  tprStorage.set(KEY, { email: hint.email, firstName: hint.firstName, avatar: hint.avatar });
}

export function getKnownUser(): KnownUser | null {
  const stored = tprStorage.get<KnownUser>(KEY);
  if (!stored || !stored.email) return null;
  return { email: stored.email, firstName: stored.firstName, avatar: stored.avatar };
}

export function clearKnownUser(): void {
  tprStorage.remove(KEY);
}
